export const environment = {
  shellEndpoint: '/shell/api/operations/v1',
  accountFlowEndpoint: '/accountflow/api',
  uaaService: '/uaa/api/auth',
  documentService: '/document/api/v1',
  documentFlowEndpoint: '/v1/documents',
  noteService: '/v1/notes',
  exceptionService: '/v1/exceptions',
  employeeService: '/v1/employees',
  financialAccountService: '/v1/financial-accounts',
  financialAccountFlow: '/financialaccountflow/api',
  transactionsService: '/v1/transactions',
};
